module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/desktop-app-3-606c7e8c286f49a5e1b1ab0525d16ac5.jpg";